import React from "react";
import Color from "color";
import { ApiBranding } from "../Replenish/api";

const lightContrastColor = "#000000";

export default (branding?: ApiBranding) => {
  if (!branding) {
    return null;
  }

  const { color, buttonPreference } = branding;
  const style = document.documentElement.style;

  if (color) {
    style.setProperty("--brand-color", color);
    style.setProperty("--brand-color-light", `${color}20`);

    if (Color(color).isLight()) {
      style.setProperty("--brand-contrast-color", lightContrastColor);
      style.setProperty("--brand-action-color", lightContrastColor);
      style.setProperty("--brand-color-light", color);
    } else {
      style.setProperty("--brand-action-color", color);
      style.setProperty("--brand-color-light", `${color}20`);
    }
  }

    if (buttonPreference && buttonPreference === "square") {
      style.setProperty("--button-radius", "0");
    }
}
